<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

        value: function() {

			var contextual = (this.item.context) ? this.item.context : this.item

            return this.$_.keys(contextual.users.played).length

        }

    }

}

</script>

<style scoped>

.plays-total {
	color: #666;
	font-size: 11px;
}

.plays span {
	z-index: 2;
}

</style>